export enum EDeliveryStatus {
  InStock = 'in_stock',
  AvailableOnRequest = 'available_on_request',
}

export enum EDeliveryStatusLabel {
  in_stock = 'В наличии',
  available_on_request = 'Доступно под заказ',
}
